import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales: ['en', 'de', 'fr', 'es', 'ja', 'ko', 'ru', 'zh'],
  defaultLocale: 'en',
  // pathnames: {
  //   '/': '/',
  //   '/pathnames': {
  //     en: '/pathnames',
  //     de: '/pfadnamen',
  //   },
  // },
})

// export type Pathnames = keyof typeof routing.pathnames
export type Locale = (typeof routing.locales)[number]

export const { Link, redirect, usePathname, useRouter } = createNavigation(routing)
